import ApiClient from '../ApiClient';

class WgptBoardListsAPI extends ApiClient {
  constructor(boardId) {
    super(`boards/${boardId}/lists`, { accountScoped: true, wgpt: true });
  }
}

export default WgptBoardListsAPI;
